import {APIService} from "../../common/APIService";
import {PurchaseOrder} from "../../dto/PurchaseOrder";

export class PurchaseOrderService extends APIService {
  public async browse(projectId: string) {
    const json = await this.getJson<{data: object[]}>(`projects/${projectId}/purchase-orders`)
    return json.data.map(item => PurchaseOrder.fromJson(item))
  }

  public async add(projectId: string, relationId: string, status: string, PONumber?: string, amount?: number, file?: File) {
    const formData = new FormData();
    formData.append('relation_id', relationId)
    formData.append('status', status)
    if (PONumber) {
      formData.append('po_number', PONumber)
    }
    if (amount) {
      formData.append('amount', Math.round(amount * 100).toString())
    }
    if (file) {
      formData.append('file', file)
    }
    const json = await this.postForm<{ data: object }>(`projects/${projectId}/purchase-orders`, formData)
    return PurchaseOrder.fromJson(json.data)
  }

  public async edit(purchaseOrderId: string, projectId: string, relationId: string, status: string, PONumber?: string, amount?: number, file?: File) {
    const formData = new FormData();
    formData.append('relation_id', relationId)
    formData.append('status', status)
    if (PONumber) {
      formData.append('po_number', PONumber)
    }
    if (amount) {
      formData.append('amount', Math.round(amount * 100).toString())
    }
    if (file) {
      formData.append('file', file)
    }
    const json = await this.putForm<{ data: object }>(`projects/${projectId}/purchase-orders/${purchaseOrderId}`, formData)
    return PurchaseOrder.fromJson(json.data)
  }

  public async delete(projectId: string, purchaseOrderId: string) {
    await this.deleteJson(`projects/${projectId}/purchase-orders/${purchaseOrderId}`)
  }

  public async download(projectId: string, purchaseOrderId: string) {
    const response = await this.getRaw(`projects/${projectId}/purchase-orders/${purchaseOrderId}/download`)
    return await response.blob();
  }
}